import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory();

export interface ISearchOrgUserItem {
	orgID: string;
	parentOrgID: string;
	orgName: string;
	level: number;
	children?: ISearchOrgUserItem[];
	userList?: ISearchUserItem[];
}
export interface ISearchUserItem {
	addressMail: string;
	familyName: string;
	firstName: string;
	loginID: string;
	role1: string;
	role2: string;
}
export interface ISearchOrgUserItemArry {
	searchOrgUserItemArry: ISearchOrgUserItem[];
}

/**
 * 組織初期化画面アクションクリエータ
 */
export const setSearchOrgUsersList = actionCreator<{
	searchOrgUserItemArry: ISearchOrgUserItem[];
}>('SET_SEARCH_QUICK_MODE_ORG_USER_REGISTER_USER');



// WEBPACK FOOTER //
// ./src/actions/quickModeOrgUserRegisterIniUser.ts